import ListUrlAction from "../../../../src/components/ListUrlAction";
import SelectDOAC from "../../../../src/components/content/SelectDOAC";
import SelectDOACIndicatie from "../../../../src/components/content/SelectDOACIndicatie";
import * as React from 'react';
export default {
  ListUrlAction,
  SelectDOAC,
  SelectDOACIndicatie,
  React
};